import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FirestoreService } from "../firebase/firestoreService";
import { FirestoreCollectionReference } from "../firebase/references";
import type { AuthAppDispatch } from "./store";

export type FacilityProvider = {
  id: string;
  FirstName?: string;
  LastName?: string;
  EmailAddresses?: string[];
  FacilityId?: string;
  IsAdmin?: boolean;
  Status?: string;
  ProfilePicUrl?: string;
  name?: string;
  email?: string;
  role_id?: string;
  is_active?: boolean;
  created_at?: string;
  invited_by?: string;
};

export interface DataState<T> {
  data: T | null;
  loading: boolean;
  error: string | null;
}

const initialState: DataState<FacilityProvider[]> = {
  data: null,
  loading: false,
  error: null,
};

const allProvidersSlice = createSlice({
  name: "allProviders",
  initialState,
  reducers: {
    getProvidersStart(state) {
      state.loading = true;
      state.error = null;
    },
    getProvidersSuccess(state, action: PayloadAction<FacilityProvider[]>) {
      state.data = action.payload;
      state.loading = false;
    },
    getProvidersFailure(state, action: PayloadAction<string>) {
      state.error = action.payload;
      state.loading = false;
    },
    resetProviders(state) {
      state.data = null;
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  getProvidersStart,
  getProvidersSuccess,
  getProvidersFailure,
  resetProviders,
} = allProvidersSlice.actions;

export const getAllProviderDetailsForClinic =
  (facilityId: string) => async (dispatch: AuthAppDispatch) => {
    dispatch(getProvidersStart());
    const unsubscribe = FirestoreService.listenToAllDocuments<FacilityProvider>(
      FirestoreCollectionReference.healthFacilityProviders(facilityId),
      (providersData) => {
        dispatch(getProvidersSuccess(providersData));
      },
      (error) => {
        dispatch(getProvidersFailure(error.message));
      },
    );

    return unsubscribe;
  };

export default allProvidersSlice.reducer;
